import { isRouteErrorResponse, useRouteError } from 'react-router'
import { ErrorPage, type ErrorReport } from '@rr/ui'
import { reportError } from '@rr/api'
import { getAuthToken } from '@/lib/auth/session'

const APP = 'rr-admin'
const APP_VERSION = import.meta.env.VITE_APP_VERSION as string | undefined
const API_URL = (import.meta.env.VITE_API_URL as string) || '/api/v1'

/**
 * Root `errorElement` for the admin router. Renders the shared `@rr/ui`
 * <ErrorPage> and wires the "send report" button to the public backend
 * endpoint via `@rr/api`. rr-admin has no i18n, so default labels apply.
 */
export default function RouteErrorBoundary() {
  const error = useRouteError()
  const statusCode = isRouteErrorResponse(error) ? error.status : undefined

  const handleReport = async (report: ErrorReport) => {
    await reportError(report, {
      baseUrl: API_URL,
      token: getAuthToken() ?? undefined,
    })
  }

  return (
    <ErrorPage
      app={APP}
      appVersion={APP_VERSION}
      error={error}
      statusCode={statusCode}
      onReport={handleReport}
      context={{ route: typeof window !== 'undefined' ? window.location.pathname : undefined }}
    />
  )
}
